import React from 'react';
import { Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'app/assets/images/back.svg';
import { ReferralHistoryList } from 'entities/Referral/components/ReferralHistoryList';
import { BitecoinSavingsBanner } from 'entities/Referral/components/BitecoinSavingsBanner';

// Figma 14500:12436: dedicated Bitecoins history screen, opened from the wallet page icon.
export const BitecoinHistoryPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="store-panel">
        <Row align="middle" onClick={() => navigate(-1)} className="pt-6 pb-4 pl-7 store-panel__container">
          <BackIcon />
          <span className="fs-xs font-weight-7">Rewards History</span>
        </Row>
      </div>
      <div className="store-panel__container pl-7 pr-7 pt-6 pb-10">
        {/* Savings banner: total spent Bitecoins across finished orders ("You've Saved P<X>"). */}
        <BitecoinSavingsBanner />
        <ReferralHistoryList />
      </div>
    </div>
  );
};
